<template>
    <div class="py-6 mt-4 text-[11px] text-gray-500 space-y-2 border-t border-white/10">
        <div class="flex flex-wrap items-center gap-x-3 gap-y-1">
            <a href="https://support.latouraineinc.com" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Support</a>
            <span class="text-[#6d6d6d]">|</span>
            <a :href="route('www.main.privacyPolicy')" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Privacy Policy</a>
            <span class="text-[#6d6d6d]">|</span>
            <a :href="route('www.main.termsOfService')" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Terms of Service</a>
        </div>
        <div class="flex flex-wrap items-center gap-x-1 gap-y-1">
            <a href="https://www.epoch.com" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Epoch.com</a>
            <span class="text-[#6d6d6d]">|</span>
            <a href="https://segpaycs.com" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Segpay.com</a>
        </div>
        <div class="flex flex-wrap items-center gap-x-1 gap-y-1">
            <a :href="route('www.main.usc2257')" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">18 USC 2257 Record-Keeping Requirements Compliance Statement</a>
            <span class="text-[#6d6d6d]">|</span>
            <a :href="route('www.main.complianceMastercard')" class="text-[#6d6d6d] hover:text-gray-300" target="_blank" rel="noopener">Compliance with MasterCard Standards</a>
        </div>
        <p class="text-[10px] text-[#8a8a8a]">Digital Experience Corporation (Registration 4804852) is an authorized payment agent.</p>
        <div class="text-[10px] text-[#8a8a8a]">
            <p class="font-bold">KALOSTA LTD (HE 488595) is an approved processing agent</p>
            <p>Naxou 1</p>
            <p>Floor 1, Office 103</p>
            <p>2043 Nicosia, Cyprus</p>
            <p>TAX ID: CY60333130O</p>
        </div>
        <p class="text-[10px]">&copy; {{ new Date().getFullYear() }} La Touraine, Inc.</p>
    </div>
</template>

<script setup>
// Shared legal/compliance footer, lifted verbatim out of ClipsSidebar so the clips
// mobile drawer can show the same block instead of a sixth inline copy. No props:
// the internal links resolve through the Ziggy `route()` global like everywhere else.
// Plain <a> (not Inertia Link) for the internal routes too — matches the Reels
// precedent (FlyoutMenu.vue) — these routes render as a modal on Inertia navigation.
</script>
